// Sentry.init({
//     dsn: "https://d5a67fe532d8400f83b5c500d87c520c@o1299664.ingest.sentry.io/6557161",
//     integrations: [new BrowserTracing()],
//     tracesSampleRate: 1.0,
// });

let scrollTop = $('.scroll-top'), customSelect = $('.select');

$(document).ready(function () {
    $('#language-choice').on('change', function () {
        window.location.href = Routing.generate('interactivo_language_change', {
            '_locale': $(this).val(),
            'locale': $(this).val(),
        })
    });

    $('.countrySelect').each(function () {
        if ($(this).hasClass('no-search-bar')) {
            $(this).select2({
                minimumResultsForSearch: Infinity
            });
        } else {
            $(this).select2();
        }
    });


    $('.select-2').each(function () {
        if ($(this).hasClass('no-search-bar')) {
            $(this).select2({
                minimumResultsForSearch: Infinity,
            });
        } else {
            $(this).select2();
        }
    });

    var $seSpan = $('#sessionTime');

    function component(x, v) {
        return Math.floor(x / v);
    }

    var $div = $seSpan;
});


if ($('.path').length) {
    scrollTop.on('click', e => {
        $('body, html').animate({scrollTop: 0}, "slow");
    });

    let width = $(window).width();

    $(window).scroll(() => {
        if (width > 992) {
            if ($(document).scrollTop() > 600) {
                scrollTop.fadeIn("slow");
            } else {
                scrollTop.fadeOut(300);
            }
        } else {
            if ($(document).scrollTop() > 10) {
                scrollTop.fadeIn("slow");
            } else {
                scrollTop.fadeOut(300);
            }
        }
    });
}

$(document).ready(function () {
    var $loader = $('.siteLoader');

    $loader.fadeOut(500, function () {
        $(this).remove();
    });
});


// FORM MASK
$(document).ready(function () {
    if ($('select.countrySelect').val() == 'PL') {
        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
    } else {
        $(this).closest('.row').find('input[data-input="phoneInput"]').unmask();
    }
});


$(document).on('change', 'select.countrySelect', function () {
    if ($(this).val() == 'PL') {
        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
    } else {
        $(this).closest('.row').find('input[data-input="phoneInput"]').unmask();
    }
});
$('.validate-postal-code').mask('00-000');
$('.validate-phone').mask('000-000-000');
// $('.validate-pesel').mask('00000000000');
$('.validate-quantity').mask('00');
$('.validate-local-number').mask('AAAAA');
$('.validate-house-number').mask('AAAAA');
$('.validate-one-number').mask('0');
$('.validate-sms').mask('000000');
$('.cryo-safe-number-mask').mask('000/00/00000');

$('#app_conversion_path_third_step_child_dateOfBirth').mask('9999-99-99');
$('#app_conversion_path_third_step_mother_dateOfBirth').mask('9999-99-99');
$('#app_conversion_path_third_step_father_dateOfBirth').mask('9999-99-99');

function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

$(".validate-number-type").on("keypress", function (evt) {
    if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
        evt.preventDefault();
    }
});

$(".validate-number-type-second").on("keypress", function (evt) {
    if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
        evt.preventDefault();
    }
});

// Dokumenty rozliczeniowy

if (($('.documentTile').length) || ($('.tile').length)) {
    $('.open-info').on('click', function () {
        if ($(this).next('.infoPanel').hasClass('active')) {
            $(this).removeClass('active');
            $('.infoPanel .nr').removeClass('active');
            $(this).next('.infoPanel').removeClass('active');
        } else {
            $('.open-info').removeClass('active');
            $('.infoPanel').removeClass('active');
            $('.infoPanel .nr').removeClass('active');
            $(this).addClass('active');
            $(this).next('.infoPanel').addClass('active');
        }

    });
    $('.info .roll').on('click', function () {
        $('.open-info').removeClass('active');
        $('.infoPanel').removeClass('active');
        $('.infoPanel .nr').removeClass('active');
    });

}

$(document).on("change", 'input[name="app_conversion_path_second_step_decision[kind]"]', e => {
    if ($('input#app_conversion_path_second_step_decision_kind_1').is(":checked")) {
        $('.comeback').fadeIn(300);
        $('#second-step-decision-btn').html(jsTranslations['messages']['next'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
        $('input#app_conversion_path_second_step_decision_account').prop("checked", "checked");
    } else {
        $('.comeback').fadeOut(0);
        $('#second-step-decision-btn').html(jsTranslations['messages']['next'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
    }
});

$(document).on("change", 'input[name="app_conversion_path_second_step_decision[account]"]', e => {
    if ($('input#app_conversion_path_second_step_decision_account').is(":checked")) {
        $('#second-step-decision-btn').html(jsTranslations['messages']['next'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
    } else {
        $('#second-step-decision-btn').html(jsTranslations['messages']['exit'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
    }
});

customSelect.on('click', e => {
    $(e.target).next().slideToggle();
});

if (customSelect.length) {
    $(document).on('click', e => {
        let target = $(e.target).attr('class'),
            list = $(e.target).closest('.select__list').attr('class');

        if (target !== 'select' && list !== 'select__list') {
            customSelect.next().slideUp();
        }
    });
}

$(document).on('click', '[type="closeReset"]', function () {

    let dataSectionExist = $(document).find('[data-section]').length,
        dataSection = $(this).closest('[data-section]'),
        dataSectionIsClosest = dataSection.length,
        lightboxOffer = $(this).closest('[data-type="offer"]').length,
        dataType = dataSection.attr('data-section');

    if (dataSectionIsClosest) {
        $(`.lightbox_wrapper[data-section="${dataType}"]`).fadeOut();
    } else if (dataSectionExist) {
        $(this).closest('.lightbox_wrapper.second-1').remove();
    } else if (lightboxOffer) {
        $('.lightbox_wrapper').fadeOut();
    } else {
        $('.lightbox_wrapper').fadeOut("normal", function () {
            $(this).remove();
        });
    }

    $('body').removeClass('unscroll');
});

$('[data-delete="offer_link"]').on('click', e => {
    let token = $(e.target).attr('data-token'),
        $element = $('input[name="token"][value="' + token + '"]');

    if (typeof $element === 'undefined') {
        return;
    }

    let $form = $element.closest('form');
    $form.submit();
});

$('[data-delete="offer"]').on('click', e => {
    let token = $(e.target).attr('data-token');

    $('.lightbox_wrapper').fadeIn();
    $('[data-delete="offer_link"]').attr({
        'href': 'javascript: void(0);',
        'data-token': token,
    });

    return false;
});
//Pass tip
$(document).ready(function () {
    $('[data="passTip"]').on('click', function () {
        var $wrapp = $('.pass_info_wrapp');
        if ($wrapp.hasClass('full')) {
            $wrapp.animate({
                height: "0px",
            }, 500).removeClass('full');
        } else {
            $wrapp.animate({
                height: $wrapp.get(0).scrollHeight,
            }, 500).addClass('full');
        }
        ;
    });
});

$(document).on('click', '#iact_core_mfa_resend', function () {
    $.ajax({
        url: Routing.generate('interactivo_core_mfa_resend_sms', {_locale: currentLocale}),
        type: 'GET',
        success: function (data, textStatus, jqXHR) {
            if (data.status === 200) {
                toastr.info(data.message);
            } else {
                toastr.error(data.message);
            }
        }
    });
});

$(document).on('click', '#iact_core_mfa_resend_email', function () {
    $.ajax({
        url: Routing.generate('interactivo_core_mfa_resend_email', {_locale: currentLocale}),
        type: 'GET',
        success: function (data, textStatus, jqXHR) {
            if (data.status === 200) {
                toastr.info(data.message);
            } else {
                toastr.error(data.message);
            }
        }
    });
});

// Prowizoryczna validacja formularza przejsciowego logowania
$(document).on('input', 'form#second-step-login-form #username, form#first-step-login-form #username', function () {
    if ($('#username_error').length) {
        $('#username_error').remove();
    }
});

$(document).on('input', 'form#second-step-login-form #password, form#first-step-login-form #password', function () {
    if ($('#password_error').length) {
        $('#password_error').remove();
    }
});

$(document).on('input', '#iact_user_resetting_password_plainPassword_first', function () {
    if ($('#iact_user_resetting_password_plainPassword_first_error').length) {
        $('#iact_user_resetting_password_plainPassword_first_error').remove();
    }
});

$(document).on('input', '#iact_partner_resetting_password_plainPassword_first', function () {
    if ($('#iact_partner_resetting_password_plainPassword_first_error').length) {
        $('#iact_partner_resetting_password_plainPassword_first_error').remove();
    }
});

$(document).on('input', '#iact_user_registration_password_plainPassword_first', function () {
    if ($('#iact_user_registration_password_plainPassword_first_error').length) {
        $('#iact_user_registration_password_plainPassword_first_error').remove();
    }
});

$(document).on('input', '#iact_partner_registration_password_plainPassword_first', function () {
    if ($('#iact_partner_registration_password_plainPassword_first_error').length) {
        $('#iact_partner_registration_password_plainPassword_first_error').remove();
    }
});

$(document).ready(function () {
    sidebarLinksCheck();
    $(window).resize(() => {
        sidebarLinksCheck();
    });

    function sidebarLinksCheck() {
        if ($('.p__dashboard').length) {
            var width = $(window).width();
            var $sidebarLink = $('.sidebarLink');
            if (width < 768 && width > 575) {
                $sidebarLink.fadeOut(0);
            } else {
                $sidebarLink.fadeIn(0);
            }
        }
    }
});


$(document).on('change', '[name="app_conversion_path_second_step[_storage]"]', function (event) {
    if ($(this).attr('id') === 'app_conversion_path_second_step__storage_1') {
        $('.abonament .inputs .choose.other-options').removeClass('active');
        $('.abonament .storage-other-options').removeClass('active');
    }
    if ($(this).attr('id') === 'app_conversion_path_second_step__storage_2') {
        $('.abonament .inputs .choose.other-options').addClass('active');
        $('.abonament .storage-other-options').addClass('active');
    }
    if ($(this).attr('id') === 'app_conversion_path_second_step__storage_3') {
        $('.abonament .inputs .choose.other-options').addClass('active');
        $('.abonament .storage-other-options').addClass('active');
    }
});


$(document).on('click', '.abonament .inputs .choose.other-options', function (event) {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.abonament .storage-other-options').removeClass('active');
    } else {
        $(this).addClass('active');
        $('.abonament .storage-other-options').addClass('active');
    }
});


// WEBPACK FOOTER //
// ./assets/js/scripts.js